/**
 * Clears the chat/LLM booking-origin markers so a fresh Shop Travel (chatless)
 * booking funnel starts as v1.
 *
 * `_zenvoya_chat_hotel_origin` / `_zenvoya_chat_flight_origin` are set when the
 * user picks a hotel/flight from a chat (conversation) search result. They drive
 * `version:"v2"` routing on hotel search, room-pricing, /hotel/availability,
 * /price/review, and prebook (see the API wrappers + resolveHotelSessionId).
 * They are cleared by the booking-exit handlers (DisplayBookingPageHeader,
 * ReviewTravelersPaymentCrumbsDetails) and /paymentsuccess — but NOT when the
 * user switches straight from a conversation search to a Shop Travel search.
 * Without clearing them there, the Shop Travel search inherited the stale "1"
 * flag and went out as v2 (only opening a NEW TAB, with fresh sessionStorage,
 * reset it). Call this at every Shop Travel ("book without itinerary") entry.
 */
import { clearChatResultsGeneratedAt } from "./chatResultsGeneratedAtStore";
import { clearShopTravelResultsExpiry } from "./shopTravelResultsExpiryStore";

export function clearChatBookingOrigin(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem("_zenvoya_chat_hotel_origin");
    sessionStorage.removeItem("_zenvoya_chat_flight_origin");
  } catch {
    /* sessionStorage unavailable (SSR / privacy mode) — nothing to clear */
  }
  // Also drop the carried chat-results 30-min TTL timestamps — they're only
  // meaningful for a chat-originated booking, so a fresh Shop Travel search
  // must not inherit a stale (or any) chat timestamp.
  clearChatResultsGeneratedAt();
  // And drop any prior Shop Travel responseExpiredAt deadline — the fresh
  // Shop Travel search about to run will re-capture its own.
  clearShopTravelResultsExpiry();
}
